<template>
    <a :href="href" :class="[
        variant === 'primary' ? 'btn-primary' : 'btn-secondary',
        iconOnly ? 'rounded-full p-4' : '',
        'btn mb-2 font-semibold',
        fullWidthMobile ? 'w-full sm:w-auto' : '',
        center ? 'text-center' : 'text-left',
        icon ? 'flex items-center' : ''
    ]" @click="handleClick">
        <span v-if="title">{{ title }}</span>
        <Icon v-if="icon" :name="icon" :class="iconOnly ? 'text-xl' : ''" class="arrow-icon" />
    </a>
</template>

<script lang="ts">
import posthog from 'posthog-js'
import { isDev } from '~/services/common'

export default {
    props: {
        href: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        variant: {
            type: String,
            default: 'primary',
            validator: (value: string) => ['primary', 'secondary'].includes(value)
        },
        fullWidthMobile: {
            type: Boolean,
            default: true
        },
        center: {
            type: Boolean,
            default: false
        },
        posthogClickEvent: {
            type: String,
            default: ''
        },
        posthogClickProperties: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        iconOnly(): boolean {
            return !this.title && !!this.icon
        }
    },
    methods: {
        handleClick() {
            if (isDev()) return

            if (this.posthogClickEvent) {
                posthog.capture(this.posthogClickEvent, this.posthogClickProperties)
            }
        }
    }
}
</script>